import type { Locale } from "../i18n/types";

/** 格式化耗时（毫秒 → 分秒） */
export function formatDuration(ms: number, locale: Locale): string {
  if (!Number.isFinite(ms) || ms < 0) ms = 0;
  const s = Math.round(ms / 1000);
  const m = Math.floor(s / 60);
  const rs = s % 60;
  if (locale === "zh") {
    return m > 0 ? `${m}分${rs}秒` : `${rs}秒`;
  }
  return m > 0 ? `${m}m${rs}s` : `${rs}s`;
}
